import ImMessage from "@/components/im/message/index";
import { on, off } from "element-ui/src/utils/dom";
import server from "@/views/agent_im/server";
import ImUserinfo from "@/components/im/userinfo/index";
import sessionTranslate from "@/views/ticket/components/sessionTranslate";
import ChatDetailModal from "@/views/zhiji/pages/robotDialogLog/components/ChatDetailModal";
import { addDays, startOfDay, endOfDay, format, subDays } from "date-fns";

export default {
    name: "sessionhistory-alert",
    components: { ImUserinfo, ImMessage, sessionTranslate, ChatDetailModal },
    props: {
        user_id: {
            type: [String, Number],
            default: ""
        },
        session_id: {
            type: [String, Number],
            default: ""
        },
        channel: {
            type: [String, Number],
            default: ""
        },
        game_id: {
            type: [String, Number],
            default: ""
        },
        channel_type: {
            type: [String, Number],
            default: ""
        },
        lang: {
            type: [String, Number],
            default: ""
        }
    },
    data() {
        return {
            show: false,
            listInfo: {},
            scrollId: 0,
            index: 0,
            translateData: "",
            isTranslate: false,
            chatData: {
                userId: this.user_id,
                startDate: format(subDays(new Date(), 10), "yyyy-MM-dd HH:mm"),
                endDate: format(new Date(), "yyyy-MM-dd HH:mm")
            }
        };
    },

    mounted() {
        let { default: [{ elm }] = [{}] } = this.$slots;
        if (elm) {
            on(elm, "click", this.showHandle);
        }
    },
    methods: {
        async getList(isfresh = false) {
            if (isfresh) {
                this.listInfo = {
                    list: [],
                    page: 0,
                    prepage: 20,
                    status: "start"
                };
            }
            if (this.listInfo.status == "nomore" || this.listInfo.status == "loading") {
                return;
            }
            this.listInfo.status = "loading";
            let list = await server.getSearchHistoryMessageList({
                user_id: this.user_id,
                page: this.listInfo.page,
                prepage: this.listInfo.prepage,
                channel: this.channel,
                game_id: this.game_id,
                channel_type: this.channel_type
            });
            list.length < this.listInfo.prepage ? (this.listInfo.status = "nomore") : (this.listInfo.page++, (this.listInfo.status = "loadingend"));
            let newlist = [];
            list.reverse();
            list.forEach(item => newlist.push(server.messageFormat(item)));
            this.listInfo.list.unshift(...newlist);
        },
        async scrollEvent(event) {
            let target = event.target || event.srcElement;
            if (target.scrollTop < 10) {
                if (this.listInfo.list.length) {
                    this.scrollId = this.listInfo.list[0].id;
                }
                await this.getList();
                this.setPosition();
            }
        },
        async showHandle() {
            this.show = true;
            await this.getList(true);
            this.scrollId = 0;
            this.setPosition();
        },
        setPosition() {
            this.$nextTick(() => {
                let scrollTarget = document.querySelector(".im-log-dialog-box"); //这里需要改获取方式
                if (this.scrollId == 0) {
                    scrollTarget.scrollTop = scrollTarget.scrollHeight;
                } else {
                    let d = scrollTarget.querySelector('[data-id="' + this.scrollId + '"]');
                    if (d) scrollTarget.scrollTop = d.offsetTop + 80;
                }
            });
        },
        loopContent(list) {
            let this_ = this;
            list.forEach(function(item) {
                if (item.children.length > 0) {
                    this_.loopContent(item.children);
                } else {
                    if (item.textContent) {
                        item.translateContent = this_.translateData.length ? this_.translateData[this_.index].output : "";
                        item.translateStatus = this_.translateData.length ? "success" : "start";
                        this_.index++;
                    }
                }
            });
        },
        handleTranslate(val) {
            if (val.length) {
                this.isTranslate = true;
            } else {
                this.isTranslate = false;
            }
            this.translateData = val;
            this.loopContent(this.listInfo.list);
            this.index = 0;
        }
    },
    destroyed() {
        let { default: [{ elm }] = [{}] } = this.$slots;
        off(elm, "click", this.showHandle);
    }
};
